export default __webpack_public_path__ + "static/media/150.6e73f8f5.png";